import { render, staticRenderFns } from "./CityPopulation.vue?vue&type=template&id=0f6e1086&"
import script from "./CityPopulation.vue?vue&type=script&lang=js&"
export * from "./CityPopulation.vue?vue&type=script&lang=js&"
import style0 from "./CityPopulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports